import React, { useEffect, useState } from 'react';
import { adminFareSettingsAPI, adminFareSettingsSaveAPI } from '../../api/admin';
import { Card, Field, Input, Btn, Row, Grid, Msg } from './ui';
import AdminFareManager from './AdminFareManager';

// 운임 관리 — ① 홈페이지 예상 운임 설정(왕복 배율·급송 가산율·기본 운임·마일리지 적립률·카카오 채널) ② 퀴노스메인과 같은 운임 관리(AdminFareManager)

function AdminFares() {
  const [settings, setSettings] = useState({ roundTripMult: 2, expressRate: 0.5, defaultFare: 15000, kakaoChannelId: '' });
  const [sMsg, setSMsg] = useState({ ok: false, text: '' });

  useEffect(() => {
    adminFareSettingsAPI().then((resp) => { if (resp && resp.status === 200) setSettings(resp.data.settings); });
  }, []);

  const setS = (k) => (e) => setSettings((st) => ({ ...st, [k]: e.target.value }));

  const saveSettings = async () => {
    setSMsg({ ok: false, text: '' });
    const resp = await adminFareSettingsSaveAPI(settings);
    if (resp && resp.status === 200) { setSettings(resp.data.settings); setSMsg({ ok: true, text: '저장했습니다.' }); }
    else setSMsg({ ok: false, text: (resp && resp.data && resp.data.message) || '저장하지 못했습니다.' });
  };

  return (
    <React.Fragment>
      <Card title="예상 운임 설정" desc="홈페이지 견적 표시에만 쓰인다 · 실제 운임은 인성 접수 뒤 정해진다">
        <Grid cols={3}>
          <Field label="왕복 배율 (편도 × 배율)"><Input type="number" step="0.1" min="1" max="5" value={settings.roundTripMult} onChange={setS('roundTripMult')} /></Field>
          <Field label="급송 가산율 (0.5 = 50%)"><Input type="number" step="0.05" min="0" max="3" value={settings.expressRate} onChange={setS('expressRate')} /></Field>
          <Field label="운임표 미등록 기본 운임"><Input type="number" step="1000" min="0" value={settings.defaultFare} onChange={setS('defaultFare')} /></Field>
        </Grid>
        <Grid cols={3}>
          <Field label="마일리지 기본 적립률 (%)"><Input type="number" step="0.5" min="0" max="100" value={settings.mileageEarnRate == null ? 1 : settings.mileageEarnRate} onChange={setS('mileageEarnRate')} /></Field>
          <Field label="카카오톡 채널 ID (실시간문의 · 카카오톡 문의)"><Input value={settings.kakaoChannelId} onChange={setS('kakaoChannelId')} placeholder="_AsExjC" /></Field>
        </Grid>
        <Row><Btn onClick={saveSettings}>저장</Btn><Msg ok={sMsg.ok}>{sMsg.text}</Msg></Row>
      </Card>

      <AdminFareManager />
    </React.Fragment>
  );
}

export default AdminFares;
